import React, { useMemo } from 'react';
import { KeyMetricData } from 'src/types';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { calculateTrendFromTimeSeries } from 'src/utils/calculateTrendFromTimeSeries';
import { useKpiUnit } from 'src/hooks/useKpiUnit';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { AggregateLevel } from 'src/types';
import { useMMDataContext } from '../../../contexts/MMDataContext';
import { KeyMetricCard } from 'src/components/molecules/KeyMetricCard';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { TrendingUp } from 'lucide-react';

type IncrementalSalesProps = {
  aggregateLevel: AggregateLevel;
};

export const IncrementalSales: React.FC<IncrementalSalesProps> = ({
  aggregateLevel,
}) => {
  const { decomps } = useMMDataContext();

  const { isEuro } = useKpiUnit();
  const { metricLabel, incrementalLabel } = useKpiMetricLabels();
  const keyMetricData: KeyMetricData = useMemo(() => {
    return {
      isLoading: decomps.isLoading,
      isError: decomps.isError,
      name: incrementalLabel,
      isEuro,
      summaryValue: decomps.total,
      data: getAggregateLevelData(decomps, aggregateLevel),
    };
  }, [decomps, isEuro, aggregateLevel, incrementalLabel]);

  const { trend, trendValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricCard
      title={`Incremental ${metricLabel}`}
      trend={trend}
      trendValue={trendValue}
      value={keyMetricData.summaryValue}
      isLoading={keyMetricData.isLoading}
      isError={keyMetricData.isError}
      icon={<ChakraIcon as={TrendingUp} boxSize={5} color="gray.500" />}
    />
  );
};
